<template>
  <v-container class="mt-5 ml-2">
    <v-snackbar v-model="snackbar" top :timeout="3000" color="error">
      Selecciona los ciclos por favor
      <v-btn text color="white" @click="snackbar = false">Cerrar</v-btn>
    </v-snackbar>

    <v-snackbar v-model="snackbarOk" top :timeout="2500" color="success">
      {{ mensajeOk }}
    </v-snackbar>

    <v-row>
      <v-col cols="12">
        <v-card outlined class="pa-3 mb-3">
          <div class="subtitle-2 grey--text text--darken-1 mb-1">Resumen NI (vista filtrada)</div>
          <v-row dense align="center">
            <v-col cols="6" sm="3"><strong>Total alumnos</strong><br />{{ kpiResumen.act }}</v-col>
            <v-col cols="6" sm="3"><strong>Alumnos NI</strong><br />{{ kpiResumen.ni }}</v-col>
            <v-col cols="6" sm="3"><strong>Meta</strong><br />{{ kpiResumen.meta }}</v-col>
            <v-col cols="6" sm="3"><strong>% NI</strong><br />{{ kpiResumen.pct }}%</v-col>
          </v-row>
        </v-card>

        <v-data-table
          :headers="headers"
          :items="nigrupos"
          class="elevation-1"
          :items-per-page="10"
          :footer-props="{ itemsPerPageOptions: [10], showFirstLastPage: true }"
          dense
          mobile-breakpoint="200"
          :height="560"
          fixed-header
          :search="search"
          sort-by="meta"
          sort-desc
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>NI GRUPOS</v-toolbar-title>
              <v-divider class="mx-4" inset vertical />
              <v-spacer />
              <v-btn class="mr-2" small dark color="green" @click="exportar()">
                <v-icon>mdi-microsoft-excel</v-icon>
              </v-btn>
              <v-btn color="primary" small @click="consultar()">Consultar</v-btn>
            </v-toolbar>
            <v-card-text class="pb-0">
              <v-row>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    outlined
                    dense
                    clearable
                    v-model="cicloInf"
                    :items="ciclos"
                    label="Selecciona ciclo actual"
                    hide-details
                    return-object
                    item-text="ciclo"
                    item-value="id_ciclo"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    outlined
                    dense
                    clearable
                    v-model="cicloSup"
                    :items="ciclos"
                    label="Selecciona siguiente ciclo"
                    hide-details
                    return-object
                    item-text="ciclo"
                    item-value="id_ciclo"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    outlined
                    dense
                    clearable
                    v-model="filterPlantel"
                    :items="plantelesOpciones"
                    label="Plantel"
                    hide-details
                    item-text="text"
                    item-value="value"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    outlined
                    dense
                    clearable
                    v-model="filterEstado"
                    :items="zonasOpciones"
                    label="Zona / región (planteles.estado)"
                    hide-details
                    item-text="text"
                    item-value="value"
                  />
                </v-col>
                <v-col cols="12" sm="6" lg="4" xl="3">
                  <v-autocomplete
                    outlined
                    dense
                    clearable
                    filled
                    v-model="filterNivel"
                    :items="nivelesSalonOpciones"
                    label="Nivel"
                    hide-details
                    item-text="text"
                    item-value="value"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text>
              <v-text-field label="Buscar" outlined dense v-model="search" hide-details />
            </v-card-text>
          </template>

          <template v-slot:item.alumnos_ciclo_actual="{ item }">
            <v-chip small color="primary" dark label @click.stop="abrirChip(item, 'actual')">
              {{ item.alumnos_ciclo_actual }}
            </v-chip>
          </template>
          <template v-slot:item.alumnos_ni="{ item }">
            <v-chip small color="teal" dark label @click.stop="abrirChip(item, 'ni')">
              {{ item.alumnos_ni != null ? item.alumnos_ni : item.alumnos_siguiente_ciclo }}
            </v-chip>
          </template>
          <template v-slot:item.meta="{ item }">
            <v-chip small color="orange" dark label>
              {{ item.meta != null ? item.meta : 0 }}
            </v-chip>
          </template>

          <template v-slot:item.porcentaje_ni="{ item }">
            {{ item.porcentaje_ni != null ? item.porcentaje_ni : '-' }}
          </template>

          <template v-slot:item.validacion="{ item }">
            <div class="d-flex align-center flex-wrap" style="gap: 6px; max-width: 220px;">
              <v-switch
                dense
                hide-details
                class="mt-0 pt-0"
                :input-value="!!Number(item.validado)"
                @change="onToggleValidado(item, $event)"
              />
              <v-text-field
                v-if="!Number(item.validado)"
                dense
                hide-details
                placeholder="Motivo"
                v-model="item.motivo"
                @blur="patchGrupo(item, { validado: false, motivo: item.motivo, comentarios: item.comentarios })"
              />
            </div>
          </template>

          <template v-slot:item.comentarios="{ item }">
            <v-textarea
              v-model="item.comentarios"
              dense
              rows="2"
              hide-details
              placeholder="Comentarios"
              @blur="patchGrupo(item, { comentarios: item.comentarios })"
            />
          </template>

        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogAlumnos" max-width="1100" scrollable>
      <v-card>
        <v-card-title class="headline">
          {{ tituloChip }}
          <v-spacer />
          <v-btn small color="green" dark class="mr-2" @click="descargarCsvDetalle">
            <v-icon left small>mdi-download</v-icon> CSV
          </v-btn>
          <v-btn icon @click="dialogAlumnos = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text style="max-height: 420px">
          <v-data-table
            :key="detalleTablaKey"
            :headers="headersAlumnosDetalle"
            :items="alumnosDetalle"
            :loading="loadingAlumnos"
            :item-class="claseFilaAlumno"
            dense
            hide-default-footer
            :items-per-page="-1"
          >
            <template v-slot:item.motivo="{ item }">
              <span v-if="item.motivo">{{ item.motivo }}</span>
              <span v-else class="grey--text">—</span>
            </template>
            <template v-slot:item.comentarios="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    :color="item.tiene_comentario ? 'amber darken-2' : 'primary'"
                    @click="abrirComentariosAlumno(item)"
                  >
                    <v-icon small>{{ item.tiene_comentario ? 'mdi-file-document' : 'mdi-file-document-outline' }}</v-icon>
                  </v-btn>
                </template>
                <span>{{ item.tiene_comentario ? 'Tiene comentarios' : 'Ver o agregar comentarios' }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogComentariosAlumno" persistent max-width="800" scrollable>
      <v-card>
        <v-card-title class="subtitle-1">
          Comentarios — {{ alumnoComentarios ? alumnoComentarios.nombre_completo : '' }}
          <v-spacer />
          <v-btn icon @click="cerrarComentariosAlumno"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text style="max-height: 360px">
          <div v-if="cargandoComentarios" class="text-center py-6">
            <v-progress-circular indeterminate color="primary" />
          </div>
          <div v-else-if="!mensajesComentarios.length" class="grey--text text-center py-6">
            Sin comentarios registrados
          </div>
          <template v-else>
            <div v-for="(msg, i) in mensajesComentarios" :key="i">
              <v-row v-if="msg.id_usuarioerp != getdatosUsuarioERPERP.iderp">
                <v-col cols="12">
                  <v-card class="ml-2 pa-3 mt-2" max-width="420" color="#f2f2f2" style="border-radius: 15px; border-top-left-radius: 0">
                    <div class="text-caption primary--text">{{ msg.usuario }}</div>
                    <div class="text-caption primary--text">{{ msg.perfil }}</div>
                    <div class="text-subtitle-2 mt-1">{{ msg.comentario }}</div>
                    <div class="text-caption grey--text">{{ msg.grupo }}</div>
                    <div class="text-caption grey--text">{{ msg.fecha_creacion }}</div>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else>
                <v-col cols="12" class="text-right">
                  <v-card class="mr-2 mt-2 pa-3 d-inline-block text-left" max-width="420" dark color="primary" style="border-radius: 15px; border-top-right-radius: 0">
                    <div class="text-subtitle-2">{{ msg.comentario }}</div>
                    <div class="text-caption">{{ msg.grupo }}</div>
                    <div class="text-caption">{{ msg.fecha_creacion }}</div>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </template>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-text-field
            v-model="mensajeComentario"
            outlined
            dense
            hide-details
            label="Escribir comentario..."
            append-icon="mdi-send"
            @click:append="guardarComentarioAlumno"
            @keyup.enter="guardarComentarioAlumno"
          />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
      <v-card width="200" color="primary" dark>
        <v-card-text align="center" class="text-h6">
          Espera por favor
          <v-progress-linear indeterminate color="white" class="mb-0 mt-2" />
        </v-card-text>
      </v-card>
    </v-overlay>

    <v-dialog v-model="dialogError" hide-overlay persistent max-width="600">
      <v-card color="error" dark style="position: relative">
        <v-card-text class="pt-2">
          Error al recuperar los datos
          <br />
          NOTA: {{ error }}
        </v-card-text>
        <v-btn color="primary" x-small absolute top right fab class="mt-5 mr-0" @click="dialogError = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'
import XLSX from 'xlsx'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    search: '',
    snackbar: false,
    snackbarOk: false,
    mensajeOk: '',
    headers: [
      { text: 'Grupo', value: 'grupo', width: '280px' },
      { text: 'Alumnos Actuales', value: 'alumnos_ciclo_actual', align: 'center' },
      { text: 'Alumnos NI', value: 'alumnos_ni', align: 'center' },
      { text: '% NI', value: 'porcentaje_ni', align: 'center' },
      { text: 'Teacher 1', value: 'teacher1' },
      { text: 'Teacher 2', value: 'teacher2' },
      { text: 'Meta', value: 'meta', align: 'center' },
      { text: 'Validación', value: 'validacion', sortable: false, width: '220px' },
      { text: 'Comentarios', value: 'comentarios', sortable: false, width: '200px' },
    ],
    headersAlumnos: [
      { text: 'Nombre', value: 'nombre_completo' },
      { text: 'Matrícula', value: 'matricula' },
      { text: 'Teléfono', value: 'telefono' },
      { text: 'Grupo', value: 'grupo' },
      { text: 'Motivo', value: 'motivo' },
      { text: 'Comentarios', value: 'comentarios', align: 'center', sortable: false, width: '90px' },
    ],
    ciclos: [],
    cicloInf: null,
    cicloSup: null,
    plantelesRaw: [],
    plantelesOpciones: [],
    zonasOpciones: [
      { text: 'Corporativo / especial (0)', value: 0 },
      { text: 'Monterrey / zona 1', value: 1 },
      { text: 'CDMX / zona 2', value: 2 },
      { text: 'Zona 3', value: 3 },
      { text: 'FAST / zona 4', value: 4 },
    ],
    filterPlantel: null,
    filterEstado: null,
    filterNivel: null,
    /** Mismos niveles de salón/grupo que Inscripciones: NIVEL 1…13, CERTIFICACION, Nivel 15. */
    nivelesSalonOpciones: [
      ...Array.from({ length: 13 }, (_, i) => {
        const label = `NIVEL ${i + 1}`
        return { text: label, value: label }
      }),
      { text: 'CERTIFICACION', value: 'CERTIFICACION' },
      { text: 'Nivel 15', value: 'Nivel 15' },
    ],
    nigrupos: [],
    overlay: false,
    dialogError: false,
    error: '',
    dialogAlumnos: false,
    tituloChip: '',
    alumnosDetalle: [],
    loadingAlumnos: false,
    chipContext: null,
    dialogComentariosAlumno: false,
    alumnoComentarios: null,
    mensajesComentarios: [],
    mensajeComentario: '',
    cargandoComentarios: false,
    detalleRequestId: 0,
    detalleCancel: null,
    detalleTablaKey: 0,
  }),

  watch: {
    dialogAlumnos(val) {
      if (!val) this.cancelarDetalleAlumnos()
    },
    cicloInf() {
      if (!this.cicloInf) {
        this.cicloSup = null
        return
      }
      const siguiente = this.resolverCicloSiguiente(this.cicloInf)
      if (siguiente) {
        this.cicloSup = siguiente
        this.overlay = true
        this.nigrupos = []
        this.consultar()
      } else {
        this.cicloSup = null
        this.nigrupos = []
        this.snackbar = true
      }
    },
  },

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    kpiResumen() {
      let act = 0
      let ni = 0
      let meta = 0
      for (const r of this.nigrupos) {
        act += Number(r.alumnos_ciclo_actual) || 0
        ni += Number(r.alumnos_ni != null ? r.alumnos_ni : r.alumnos_siguiente_ciclo) || 0
        meta += Number(r.meta) || 0
      }
      const pct = meta > 0 ? ((ni / meta) * 100).toFixed(2) : '0.00'
      return { act, ni, meta, pct }
    },
    /** Motivo solo aplica al chip TOTAL (alumnos que no entran como NI). */
    headersAlumnosDetalle() {
      const tipo = this.chipContext && this.chipContext.tipo
      if (tipo === 'actual') return this.headersAlumnos
      return this.headersAlumnos.filter((h) => h.value !== 'motivo')
    },
  },

  created() {
    this.initialize()
  },

  methods: {
    claseFilaAlumno(item) {
      if (!item) return ''
      if (item.tiene_comentario) return 'fila-con-comentario'
      if (item.es_ni === false) return 'fila-no-ni'
      return ''
    },

    errMsg(err) {
      return (
        (err.response && err.response.data && (err.response.data.message || err.response.data.Message)) ||
        err.message ||
        String(err)
      )
    },

    cancelarDetalleAlumnos() {
      this.detalleRequestId += 1
      if (this.detalleCancel) {
        this.detalleCancel('cancelado')
        this.detalleCancel = null
      }
      this.loadingAlumnos = false
    },

    esCancelacionDetalle(err) {
      return axios.isCancel(err) || (err && err.message === 'cancelado')
    },

    initialize() {
      this.ciclos = []
      this.plantelesRaw = []
      this.plantelesOpciones = []
      this.$http
        .get('kpi.planteles.all')
        .then((response) => {
          this.plantelesRaw = response.data || []
          this.armarPlantelesOpciones()
          return this.$http.get('kpi.ciclos.all')
        })
        .then((response) => {
          for (const i in response.data) {
            if (!(response.data[i].ciclo.search('FE') !== -1)) {
              if (response.data[i].ciclo.search('CICLO') !== -1) {
                this.ciclos.push(response.data[i])
              }
            }
          }
        })
        .catch((e) => console.log(e))
    },

    armarPlantelesOpciones() {
      const u = this.getdatosUsuarioERPERP
      const recep =
        u &&
        u.idpuesto === 19 &&
        ![568, 7, 161].includes(u.iderp) &&
        Array.isArray(u.planteles)
      let rows = (this.plantelesRaw || []).map((p) => ({
        text: p.plantel,
        value: p.id_plantel,
        estado: p.estado,
      }))
      if (recep) {
        const permitidos = new Set(u.planteles.map((x) => x.idplantel))
        rows = rows.filter((r) => permitidos.has(r.value))
      }
      this.plantelesOpciones = rows.sort((a, b) => a.text.localeCompare(b.text))
    },

    resolverCicloSiguiente(cicloActual) {
      if (!cicloActual || !this.ciclos.length) return null
      const m = String(cicloActual.ciclo || '').match(/CICLO\s+(\d{2})_(\d{2})/i)
      if (!m) return null
      const nextNum = String(parseInt(m[1], 10) + 1).padStart(2, '0')
      const target = `CICLO ${nextNum}_${m[2]}`
      return this.ciclos.find((c) => c.ciclo === target) || null
    },

    urlnigrupos() {
      let url =
        'kpi.ni.grupos/' +
        this.cicloInf.id_ciclo +
        '/' +
        this.cicloInf.id_ciclo_relacionado +
        '/' +
        this.cicloSup.id_ciclo +
        '/' +
        this.cicloSup.id_ciclo_relacionado
      const q = []
      if (this.filterPlantel != null && this.filterPlantel !== '') {
        q.push('id_plantel=' + encodeURIComponent(this.filterPlantel))
      }
      if (this.filterEstado != null && this.filterEstado !== '') {
        q.push('id_estado=' + encodeURIComponent(this.filterEstado))
      }
      if (this.filterNivel != null && this.filterNivel !== '') {
        q.push('nivel=' + encodeURIComponent(this.filterNivel))
      }
      if (q.length) url += '?' + q.join('&')
      return url
    },

    async consultar() {
      if (!this.cicloInf || !this.cicloSup) {
        this.snackbar = true
        return
      }
      this.overlay = true
      this.nigrupos = []
      await this.getGrupos()
    },

    getGrupos() {
      return this.$http
        .get(this.urlnigrupos())
        .then((response) => {
          const data = response.data || []
          const u = this.getdatosUsuarioERPERP
          if (u && u.idpuesto === 19 && ![568, 7, 161].includes(u.iderp)) {
            const rows = []
            for (const i in data) {
              const plantel = u.planteles && u.planteles.find((el) => el.idplantel === data[i].id_plantel)
              if (plantel) rows.push(data[i])
            }
            this.nigrupos = rows
          } else {
            this.nigrupos = data
          }
          this.overlay = false
        })
        .catch((error) => {
          this.error = this.errMsg(error)
          this.dialogError = true
          this.overlay = false
        })
    },

    abrirChip(item, tipo) {
      if (!this.cicloInf || !this.cicloSup) {
        this.snackbar = true
        return
      }
      const map = { actual: 'TOTAL', siguiente: 'Alumnos NI', ni: 'Alumnos NI' }
      this.tituloChip = `${item.grupo || ''} — ${map[tipo] || tipo}`
      this.chipContext = { item, tipo }
      this.dialogAlumnos = true
      this.cargarDetalleAlumnos()
    },

    cargarDetalleAlumnos() {
      if (!this.chipContext || !this.cicloInf || !this.cicloSup) return Promise.resolve()
      const { item, tipo } = this.chipContext
      this.cancelarDetalleAlumnos()
      const requestId = this.detalleRequestId
      this.alumnosDetalle = []
      this.loadingAlumnos = true
      const cancelSource = axios.CancelToken.source()
      this.detalleCancel = cancelSource.cancel
      const base =
        'kpi.ni.grupo.alumnos/' +
        item.id_grupo +
        '/' +
        this.cicloInf.id_ciclo +
        '/' +
        this.cicloInf.id_ciclo_relacionado +
        '/' +
        this.cicloSup.id_ciclo +
        '/' +
        this.cicloSup.id_ciclo_relacionado
      return this.$http
        .get(base + '?tipo=' + encodeURIComponent(tipo), { cancelToken: cancelSource.token })
        .then((res) => {
          if (requestId !== this.detalleRequestId) return
          const rows = (res.data && res.data.alumnos) || []
          this.alumnosDetalle = rows
          this.detalleTablaKey += 1
        })
        .catch((e) => {
          if (this.esCancelacionDetalle(e)) return
          if (requestId !== this.detalleRequestId) return
          this.error = this.errMsg(e)
          this.dialogError = true
        })
        .finally(() => {
          if (requestId !== this.detalleRequestId) return
          this.loadingAlumnos = false
          this.detalleCancel = null
        })
    },

    abrirComentariosAlumno(item) {
      if (!item || !item.id_alumno) {
        this.error = 'No se encontró el alumno'
        this.dialogError = true
        return
      }
      this.alumnoComentarios = item
      this.mensajesComentarios = []
      this.mensajeComentario = ''
      this.dialogComentariosAlumno = true
      this.cargarComentariosAlumno(item)
    },

    cerrarComentariosAlumno() {
      this.dialogComentariosAlumno = false
      this.alumnoComentarios = null
      this.mensajesComentarios = []
      this.mensajeComentario = ''
    },

    cargarComentariosAlumno(item) {
      const escuela = item.unidad_negocio || 1
      this.cargandoComentarios = true
      this.$http
        .get(`operaciones.comentario/${item.id_alumno}/${escuela}`)
        .then((res) => {
          this.mensajesComentarios = res.data || []
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
        })
        .finally(() => {
          this.cargandoComentarios = false
        })
    },

    guardarComentarioAlumno() {
      const texto = (this.mensajeComentario || '').trim()
      if (!texto) {
        this.error = 'Ingresa un comentario'
        this.dialogError = true
        return
      }
      if (!this.alumnoComentarios || !this.chipContext) {
        this.error = 'No hay contexto de grupo'
        this.dialogError = true
        return
      }
      const u = this.getdatosUsuarioERPERP
      const grupo = this.chipContext.item
      const payload = {
        id_alumno: this.alumnoComentarios.id_alumno,
        id_usuarioerp: u.iderp,
        id_grupo: grupo.id_grupo,
        id_ciclo: this.cicloInf.id_ciclo,
        comentario: texto,
        idperfil: u.idpuesto,
        unidad_negocio: this.alumnoComentarios.unidad_negocio || 1,
        grupo: grupo.grupo || this.alumnoComentarios.grupo,
        perfil: u.puesto,
      }
      this.cargandoComentarios = true
      this.$http
        .post('operaciones.comentario', payload)
        .then(() => {
          this.mensajeComentario = ''
          this.mensajeOk = 'Comentario guardado'
          this.snackbarOk = true
          if (this.alumnoComentarios) {
            this.$set(this.alumnoComentarios, 'tiene_comentario', true)
            const id = Number(this.alumnoComentarios.id_alumno)
            const row = this.alumnosDetalle.find((a) => Number(a.id_alumno) === id)
            if (row) this.$set(row, 'tiene_comentario', true)
            this.detalleTablaKey += 1
          }
          this.cargarComentariosAlumno(this.alumnoComentarios)
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
          this.cargandoComentarios = false
        })
    },

    descargarCsvDetalle() {
      if (!this.chipContext || !this.cicloInf || !this.cicloSup) return
      const { item, tipo } = this.chipContext
      const path =
        'kpi.ni.grupo.alumnos/' +
        item.id_grupo +
        '/' +
        this.cicloInf.id_ciclo +
        '/' +
        this.cicloInf.id_ciclo_relacionado +
        '/' +
        this.cicloSup.id_ciclo +
        '/' +
        this.cicloSup.id_ciclo_relacionado +
        '?tipo=' +
        encodeURIComponent(tipo) +
        '&export=csv'
      this.$http
        .get(path, { responseType: 'blob' })
        .then((res) => {
          const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' })
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `ni-grupo-${item.id_grupo}-${tipo}.csv`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
        })
    },

    onToggleValidado(item, val) {
      this.patchGrupo(item, { validado: !!val, motivo: item.motivo || '', comentarios: item.comentarios })
    },

    patchGrupo(item, partial) {
      const body = {}
      if (partial.validado !== undefined) body.validado = partial.validado
      if (partial.motivo !== undefined) body.motivo = partial.motivo
      if (partial.comentarios !== undefined) body.comentarios = partial.comentarios
      this.$http
        .patch('kpi.ri.grupo.recepcion/' + item.id_grupo, body)
        .then(() => {
          this.mensajeOk = 'Guardado'
          this.snackbarOk = true
        })
        .catch((e) => {
          this.error = this.errMsg(e)
          this.dialogError = true
        })
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
      return buf
    },

    exportar() {
      let data = XLSX.utils.json_to_sheet(this.nigrupos)
      const workbook = XLSX.utils.book_new()
      const filename = 'NI_grupos'
      XLSX.utils.book_append_sheet(workbook, data, filename)
      const wbout = XLSX.write(workbook, {
        bookType: 'xls',
        bookSST: false,
        type: 'binary',
      })
      const file = new File([new Blob([this.s2ab(wbout)])], filename + '.xls')
      const formData = new FormData()
      formData.append('file', file)
      this.$http
        .post('pdfs', formData)
        .then(() => {
          window.location = axios.defaults.baseURL + 'pdfs/' + filename + '.xls'
        })
        .catch((error) => {
          alert(this.errMsg(error))
          console.log(error)
        })
    },
  },
}
</script>

<style scoped>
::v-deep tr.fila-no-ni {
  background-color: #bbdefb !important;
}
::v-deep tr.fila-no-ni:hover {
  background-color: #90caf9 !important;
}
::v-deep tr.fila-con-comentario {
  background-color: #ffe082 !important;
}
::v-deep tr.fila-con-comentario:hover {
  background-color: #ffd54f !important;
}
</style>
